import { createAsyncThunk } from "@reduxjs/toolkit";
import customFetch from "../../util/config/axiosConfig";
import { getDataUserId } from "../../util/manageAuth";
import { DashboardData, ChartData, ChartType } from "../../types/dashboardType";
import { ApiResponse } from "../../types/responseType";

export const fetchDashboardData = createAsyncThunk<
    DashboardData,
    void,
    { rejectValue: string }
>(
    "dashboard/fetchDashboardData",
    async (_, thunkAPI) => {
        try {
            const userId = getDataUserId();

            if (!userId) {
                return thunkAPI.rejectWithValue("User not authenticated");
            }

            const response = await customFetch.get<ApiResponse<DashboardData>>(
                `/dashboard/whatsapp/${userId}`
            );

            const responseData = response.data;

            if (responseData.status !== 1) {
                return thunkAPI.rejectWithValue(
                    responseData.error?.message || "Failed to fetch dashboard data"
                );
            }

            return responseData.data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(
                error?.response?.data?.error?.message ||
                error?.message ||
                "Failed to fetch dashboard data"
            );
        }
    }
);

export const fetchChartData = createAsyncThunk<
    ChartData,
    ChartType,
    { rejectValue: string }
>(
    "dashboard/fetchChartData",
    async (type, thunkAPI) => {
        try {
            const userId = getDataUserId();

            if (!userId) {
                return thunkAPI.rejectWithValue("User not authenticated");
            }

            const response = await customFetch.get<ApiResponse<ChartData>>(
                `/dashboard/whatsapp/chart/${userId}`,
                { params: { type } }
            );

            const responseData = response.data;

            if (responseData.status !== 1) {
                return thunkAPI.rejectWithValue(
                    responseData.error?.message || "Failed to fetch chart data"
                );
            }

            return responseData.data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(
                error?.response?.data?.error?.message ||
                error?.message ||
                "Failed to fetch chart data"
            );
        }
    }
);

export const validateSuperAdminPassword = createAsyncThunk<
  any,
  { userId: number; password: string }
>(
  "superAdmin/validatePassword",
  async (payload, thunkAPI) => {
    try {
      const response = await customFetch.post(
        "/api/super-admin/validate-password",
        payload
      );

      return response.data;
    } catch (error: any) {
      const msg =
        error?.response?.data?.message ||
        "Password validation failed";

      return thunkAPI.rejectWithValue(msg);
    }
  }
);
